// The site's popup (scss/_son-dialog.scss). confirmDialog() resolves true on the
// confirm button; the cancel button, Escape and a click on the backdrop resolve false.
// infoDialog() is the one-button notice.

export function confirmDialog({ title, text, confirm, cancel }) {
    return new Promise((resolve) => {
        const dialog = document.createElement('dialog');
        dialog.className = 'son-dialog';
        dialog.setAttribute('aria-labelledby', 'son-dialog-title');
        dialog.innerHTML =
            '<h3 class="son-dialog__title" id="son-dialog-title"></h3>' +
            '<p class="son-dialog__text"></p>' +
            '<div class="son-dialog__actions">' +
            '<button type="button" class="son-dialog__button" value="cancel" autofocus><span class="son-btn-label"></span></button>' +
            '<button type="button" class="son-dialog__button" value="confirm"><span class="son-btn-label"></span></button>' +
            '</div>';

        dialog.querySelector('.son-dialog__title').textContent = title;
        dialog.querySelector('.son-dialog__text').textContent = text;
        const [cancelButton, confirmButton] = dialog.querySelectorAll('.son-dialog__button');
        cancelButton.firstChild.textContent = cancel;
        confirmButton.firstChild.textContent = confirm;

        let done = false;
        const finish = (value) => {
            if (done) {
                return;
            }
            done = true;
            if (dialog.open) {
                dialog.close(value);
            }
            dialog.remove();
            resolve(value === 'confirm');
        };

        dialog.addEventListener('click', (event) => {
            const button = event.target.closest('.son-dialog__button');
            if (button) {
                finish(button.value);
                return;
            }

            // the dialog element itself also covers its padding, so only a click outside its box is the backdrop
            const box = dialog.getBoundingClientRect();
            const outside = event.clientX < box.left || event.clientX > box.right
                || event.clientY < box.top || event.clientY > box.bottom;
            if (event.target === dialog && outside) {
                finish('cancel');
            }
        });

        // Escape; not settled via 'close' alone - Chrome fires that on the next animation frame, never in a background tab
        dialog.addEventListener('cancel', () => finish('cancel'));
        dialog.addEventListener('close', () => finish('cancel'));

        document.body.append(dialog);
        dialog.showModal();
    });
}

// One-button notice in the same popup: resolves once it is closed, however that happens.
// An empty title or text is left out.
export function infoDialog({ title, text, button }) {
    return new Promise((resolve) => {
        const dialog = document.createElement('dialog');
        dialog.className = 'son-dialog';
        dialog.setAttribute('aria-labelledby', 'son-dialog-info-title');
        dialog.setAttribute('aria-describedby', 'son-dialog-info-text');
        dialog.innerHTML =
            '<h3 class="son-dialog__title" id="son-dialog-info-title"></h3>' +
            '<p class="son-dialog__text" id="son-dialog-info-text"></p>' +
            '<div class="son-dialog__actions">' +
            '<button type="button" class="son-dialog__button" autofocus><span class="son-btn-label"></span></button>' +
            '</div>';

        const titleElement = dialog.querySelector('.son-dialog__title');
        const textElement = dialog.querySelector('.son-dialog__text');
        titleElement.textContent = title || '';
        textElement.textContent = text || '';
        titleElement.hidden = !title;
        textElement.hidden = !text;
        dialog.querySelector('.son-btn-label').textContent = button;

        let done = false;
        const finish = () => {
            if (done) {
                return;
            }
            done = true;
            if (dialog.open) {
                dialog.close();
            }
            dialog.remove();
            resolve();
        };

        dialog.addEventListener('click', (event) => {
            const box = dialog.getBoundingClientRect();
            const outside = event.clientX < box.left || event.clientX > box.right
                || event.clientY < box.top || event.clientY > box.bottom;
            if (event.target.closest('.son-dialog__button') || (event.target === dialog && outside)) {
                finish();
            }
        });
        dialog.addEventListener('cancel', finish);
        dialog.addEventListener('close', finish);

        document.body.append(dialog);
        dialog.showModal();
    });
}
